var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{class:{ 'transparent': _vm.transparent }},[_c('nav',[_c('div',{staticClass:"logo-wrapper"},[_c('a',{attrs:{"href":"https://www.smart-crm.me/"}},[_c('img',{attrs:{"src":require('@/assets/images/logo.webp')}})])])])])}
var staticRenderFns = []

export { render, staticRenderFns }